import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export default function Seo({ title, siteName, description, image, type = "website", jsonLd }) {
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;
    setLink("canonical", url);
    setMeta("property", "og:url", url);
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:type", type);
    if (siteName) setMeta("property", "og:site_name", siteName);
    if (image) {
      const abs = image.startsWith("http") ? image : window.location.origin + image;
      setMeta("property", "og:image", abs);
      setMeta("name", "twitter:card", "summary_large_image");
      setMeta("name", "twitter:image", abs);
    }
    let script = document.head.querySelector('script[data-seo-jsonld="true"]');
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute("data-seo-jsonld", "true");
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, siteName, description, image, type, jsonLd]);
  return null;
}
